import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useBooleanState } from "hooks";

import { useAddNewHubToPractice } from "./hooks";
import { AddNewHubForm } from "./components";

export function AddHub({ onDone }) {
  const [isModalOpen, openModal, closeModal] = useBooleanState();

  const { addNewHubToPractice, processing } = useAddNewHubToPractice(() => {
    closeModal();
    onDone();
  });

  return (
    <React.Fragment>
      <Button primary onClick={openModal} content="Create Hub" />
      {isModalOpen && (
        <AddNewHubForm
          onSubmit={addNewHubToPractice}
          loading={processing}
          onClose={closeModal}
        />
      )}
    </React.Fragment>
  );
}

AddHub.propTypes = { onDone: PropTypes.func };
AddHub.defaultProps = { onDone: () => {} };

export default AddHub;
